import styled from 'styled-components';

export const CardOuterWrapper = styled.div(
  props => `
    width: 100%;
    margin: 2rem 0px;
    margin-bottom: 10px;    
    `,
);

export const CardInnerWrapper = styled.div(
  props => `
    width: 100%;
    margin: 0 auto;
    max-width: 120rem;
    background-color: #FFFFFF;
    border-radius: 1.2000000000000002rem
    margin: 0 auto;
    display: flex;
    align-items:center;
    padding: 12px 20px;
    .certifiedText {
        font-size: 16px;
        color: #46484D;
    }
    `,
);

export const FeatureList = styled.ul(
  props => `
      display: flex;
      align-items:center;
      `,
);

export const FeatureListItem = styled.li(
  props => `
      display: flex;
      align-items:center;
      flex-shrink: 0;
      margin-right: 20px;
      padding-left: 5px;
      .descText {
              font-weight: 600;
        font-size: 16px;

        color: #232A67;
        padding-right: 24px;
       }
        .bannerImg {
        width: 43px;
        height: 44px;
        margin-right: 12px;
       }
       .rightLine {
        height: 30px;
        width: 1px;
        background: #D6D6D6;
       }
       :first-child {
        padding-left: 0;
       }
      `,
);
